import { render } from "./post-training-opportunities.vue?vue&type=template&id=52068ff8&scoped=true"
import script from "./post-training-opportunities.vue?vue&type=script&lang=js"
export * from "./post-training-opportunities.vue?vue&type=script&lang=js"

import "./post-training-opportunities.vue?vue&type=style&index=0&id=52068ff8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52068ff8"

export default script